var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDedicated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.4,392C76.3,405.5,72,421,72,436.8V488h112v-51.2c0-15.9-4.3-31.3-12.4-44.8H84.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72,128c0-13.2,10.8-24,24-24s24,10.8,24,24v8h88c4.4,0,8-3.6,8-8V64c0-4.4-3.6-8-8-8H32c-4.4,0-8,3.6-8,8v64 c0,4.4,3.6,8,8,8h40V128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200,244.5c0-3.7-2.5-6.9-6.1-7.8l-9.9-2.5V304h-16v-73.8l-16-4V304h-16v-81.8l-16-4V304h-16V197.8V128 c0-4.4-3.6-8-8-8s-8,3.6-8,8v139.1V280v24H72v-24v-12.9c0-14.9-12.1-27.1-27.1-27.1c-2.7,0-4.9,2.2-4.9,4.9c0,0.8,0.2,1.5,0.5,2.2 l9.6,19.1c3.9,7.7,5.9,16.4,5.9,25v35.8c0,9,3.1,17.9,8.8,25L83.8,376h88.3l19.1-23.8c5.7-7.1,8.8-15.9,8.8-25L200,244.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 416,
    cy: 400,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416,344c-39.7,0-72,32.3-72,72c0,16.4,5.6,31.4,14.8,43.5c6.6-13.3,17.5-23.8,30.7-29.8 c-8.2-7.3-13.5-17.9-13.5-29.7c0-22.1,17.9-40,40-40s40,17.9,40,40c0,11.9-5.3,22.4-13.5,29.7c13.3,6,24.2,16.5,30.7,29.8 c9.2-12.1,14.8-27.2,14.8-43.5C488,376.3,455.7,344,416,344z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416,440c-20.5,0-38.4,13-45.1,32.1C383.3,482,399,488,416,488s32.7-6,45.1-15.9C454.4,453,436.5,440,416,440z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 416,
    cy: 80,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M370.9,152.1C383.3,162,399,168,416,168s32.7-6,45.1-15.9c-6.7-19-24.5-32.1-45.1-32.1S377.6,133,370.9,152.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M389.5,109.7C381.3,102.4,376,91.9,376,80c0-22.1,17.9-40,40-40s40,17.9,40,40c0,11.9-5.3,22.4-13.5,29.7 c13.3,6,24.2,16.5,30.7,29.8c9.2-12.1,14.8-27.2,14.8-43.5c0-39.7-32.3-72-72-72s-72,32.3-72,72c0,16.4,5.6,31.4,14.8,43.5 C365.4,126.2,376.2,115.8,389.5,109.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264,256c0,16.4,5.6,31.4,14.8,43.5c6.6-13.3,17.5-23.8,30.7-29.8c-8.2-7.3-13.5-17.9-13.5-29.7 c0-22.1,17.9-40,40-40s40,17.9,40,40c0,11.9-5.3,22.4-13.5,29.7c13.3,6,24.2,16.5,30.7,29.8c9.2-12.1,14.8-27.2,14.8-43.5 c0-39.7-32.3-72-72-72S264,216.3,264,256L264,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336,280c-20.5,0-38.4,13-45.1,32.1C303.3,322,319,328,336,328s32.7-6,45.1-15.9C374.4,293,356.5,280,336,280z "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 336,
    cy: 240,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M328,96c0-2.7,0.2-5.4,0.4-8H232v16h96.4C328.2,101.4,328,98.7,328,96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M216,248v16h32.4c-0.2-2.6-0.4-5.3-0.4-8c0-2.7,0.2-5.4,0.4-8H216z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.8,408c1.5,5.2,2.7,10.6,3.3,16h129.2c-0.2-2.6-0.4-5.3-0.4-8c0-2.7,0.2-5.4,0.4-8H195.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDedicated);
export default __webpack_public_path__ + "static/media/Dedicated.5386228e0910680e33d4331fdc197c2d.svg";
export { ForwardRef as ReactComponent };